import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Close, Verified } from '@mui/icons-material';
import { recentPurchases } from '../data/recentPurchases';
const INTERVAL_MS = 15000;
const VISIBLE_MS = 5000;
const FIRST_DELAY_MS = 5000;
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let current = Math.floor(Math.random() * recentPurchases.length);
    const show = () => {
      setIndex(current);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
      current = (current + 1) % recentPurchases.length;
    };
    const firstTimer = setTimeout(show, FIRST_DELAY_MS);
    const interval = setInterval(show, INTERVAL_MS);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = recentPurchases[index];
  return <div className="fixed left-3 sm:left-5 bottom-28 sm:bottom-24 z-[60] pointer-events-none" aria-live="polite" data-id="element-131" data-mp="1xdxxp72s6bk9">
      <AnimatePresence data-id="element-132" data-mp="1jharsesuob27">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 380,
        damping: 30
      }} className="pointer-events-auto relative flex items-center gap-3 bg-white rounded-2xl shadow-2xl border border-slate-100 p-3 pr-9 max-w-[320px]" data-id="element-133" data-mp="1nfs194zqtxms">
            <div className="w-12 h-12 shrink-0 rounded-xl bg-brand-50 flex items-center justify-center text-2xl" data-id="element-134" data-mp="qqkczp7qpaf6">
              {purchase.flag}
            </div>
            <div className="min-w-0" data-id="element-135" data-mp="vp40vv5w8wa6">
              <p className="text-sm text-slate-900 leading-snug" data-id="element-136" data-mp="2xet1j2wsau7k">
                <span className="font-bold" data-id="element-137" data-mp="2xg46h61yu809">{purchase.name}</span> de{' '}
                {purchase.city}, {purchase.country}
              </p>
              <p className="text-sm text-slate-600 leading-snug" data-id="element-138" data-mp="2noqb9ah1rucx">
                compró el <span className="font-bold text-brand-700" data-id="element-139" data-mp="2nmnbvzu08ovj">Pack 100 Citas</span>
              </p>
              <p className="flex items-center gap-1 text-xs text-slate-400 mt-0.5" data-id="element-140" data-mp="2jllabccm80qe">
                <Verified sx={{
              fontSize: 14
            }} className="text-green-500" data-id="element-141" data-mp="3gcvvzx83pjcr" />
                Compra verificada · hace {purchase.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors" aria-label="Cerrar notificación" data-id="element-142" data-mp="37bnxpf5l4iio">
              <Close sx={{
            fontSize: 16
          }} data-id="element-143" data-mp="1r13l1uakh87x" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}